import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-open_icon",
  "use": "icon-open_icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-open_icon\"><defs><style type=\"text/css\"></style></defs><path d=\"M250.43162 211.379413l-60.943176 60.943177 301.698893 301.698893L552.130513 513.078307z\" p-id=\"20135\" /><path d=\"M250.583856 814.877898l-60.943176-60.943176 301.698893-301.698893L552.282749 513.179005z\" p-id=\"20136\" /><path d=\"M549.105906 211.376258l-60.943177 60.943176 301.698893 301.698893L850.804799 513.075151z\" p-id=\"20137\" /><path d=\"M549.227972 814.932341l-60.943177-60.943176 301.698894-301.698893L850.926865 513.233448z\" p-id=\"20138\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/open_icon.svg
// module id = bcCF
// module chunks = 5